import type { EnvConfig } from '@/types/config/env-config.types';

let _envConfig: EnvConfig | null = null;

export const configureEnv = (config: EnvConfig): void => {
    _envConfig = config;
};

export const getEnvConfig = (): EnvConfig => {
    if (_envConfig) {
        return _envConfig;
    }

    // page build fallback：import.meta.env 已於 build time 燒入正確 URL
    const mallBaseUrl = import.meta.env.VITE_APP_MALL_BASE_URL || '';
    if (!mallBaseUrl) {
        console.warn(
            '[gh-components] configureEnv() 尚未呼叫，且無法從環境變數取得 MALL_BASE_URL。' +
                '請在掛載元件前呼叫 configureEnv() 設定 API 環境。'
        );
    }

    return {
        VUE_APP_SHOP_CODE: import.meta.env.VITE_APP_SHOP_CODE || '',
        VUE_APP_SHOP_CODE_2: import.meta.env.VITE_APP_SHOP_CODE_2 || '',
        EC_BASE_URL: import.meta.env.VITE_APP_EC_BASE_URL || '',
        MALL_BASE_URL: mallBaseUrl,
        OAUTH_BASE_URL: import.meta.env.VITE_APP_OAUTH_BASE_URL || '',
    };
};
